import Vue from 'vue'
import multiselect from 'vue-multiselect'
import SelectCulture from '@/components/SelectCulture'
import SelectTypeSol from '@/components/SelectTypeSol'
import SelectStade from '@/components/SelectStade'
import Breadcrumb from '@/components/Breadcrumb'
import Module from '@/components/Module'
import Row from '@/components/Row'
import FieldError from '@/components/FieldError'
import FieldAbstract from '@/components/FieldAbstract'
import FieldText from '@/components/FieldText'
import FieldInteger from '@/components/FieldInteger'
import FieldFloat from '@/components/FieldFloat'
import FieldDate from '@/components/FieldDate'
import FieldSelect from '@/components/FieldSelect'
import FieldSelectBoolean from '@/components/FieldSelectBoolean'

import VuePlotly from '@statnett/vue-plotly'

import Plotly from 'plotly.js'
import plotFR from 'plotly.js/lib/locales/fr'

Plotly.register(plotFR)
Plotly.setPlotConfig({ locale: 'fr' })

// Register a global custom directive called `v-focus`
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

Vue.component('v-multiselect', multiselect)
Vue.component('v-select-culture', SelectCulture)
Vue.component('v-select-type-sol', SelectTypeSol)
Vue.component('v-select-stade', SelectStade)

Vue.component('v-breadcrumb', Breadcrumb)
Vue.component('v-module', Module)
Vue.component('v-row', Row)
Vue.component('v-error-ct', FieldError)
Vue.component('v-field', FieldAbstract)
Vue.component('v-field-text', FieldText)
Vue.component('v-field-integer', FieldInteger)
Vue.component('v-field-float', FieldFloat)
Vue.component('v-field-date', FieldDate)
Vue.component('v-field-select', FieldSelect)
Vue.component('v-field-select-bool', FieldSelectBoolean)

Vue.component('v-graph', VuePlotly)
